import gql from "graphql-tag";
import {IDS} from "../../Constants/IDS";

export function generate_FETCH_SALES_ORDERS(name, type = 'query') {
    return gql`
  ${type} ${name}($startDate:timestamptz!, $endDate:timestamptz!, $status:[uuid!], $distributorId:uuid!, $search:String, $offset: Int!, $limit: Int!, $orderBy: [Orders_order_by!]){
   ${name}: Orders(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { status: {_in: $status}}, { from: {_eq: $distributorId}}, 
        {_or:[{orderNum:{_ilike:$search}}, {Organization:{name:{_ilike:$search}}}, {Organization:{Users:{name:{_ilike:$search}}}}]} ]}, 
        offset: $offset, limit: $limit, order_by: $orderBy ){
    id
    orderNum    
    OrderItems_aggregate(distinct_on: productId) { aggregate { count } }
    created_at
    updated_at
    roundOfValue
    finalPrice    
    status
    TripOrderStatus {id name}
    ToRouteShops {id Route{id name}}                
    Organization{ id name Users(where:{userTypeId:{_eq:"${IDS.userTypes.Customer}"}}){id name} }
 }
}`
}

export function generate_SUBSCRIBE_SALES_ORDERS_COUNT(name) {
    return gql`
  subscription ${name}($startDate:timestamptz!, $endDate:timestamptz!, $status:[uuid!], $distributorId:uuid!, $search:String){
   ${name}: Orders_aggregate(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { status: {_in: $status}}, { from: {_eq: $distributorId}}, 
        {_or:[{orderNum:{_ilike:$search}}, {Organization:{name:{_ilike:$search}}}, {Organization:{Users:{name:{_ilike:$search}}}}]} ]} ){
    aggregate { count }                
   }
}`
}